module.exports = __webpack_public_path__ + "static/media/HeaderBg.c2eb23f5.png";